var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',[_c('h1',{staticClass:"error-title mt-8"},[_vm._v("404 - Page not found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }